var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1890_228766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.09345 5.02253C8.51157 5.02253 7.61084 4.39377 6.66228 4.4165C5.41083 4.43165 4.263 5.10585 3.61734 6.17398C2.31806 8.31781 3.28256 11.4843 4.54996 13.2267C5.1717 14.0751 5.90503 15.0296 6.8775 14.9993C7.81011 14.9614 8.16084 14.4236 9.29273 14.4236C10.4166 14.4236 10.7355 14.9993 11.7239 14.9766C12.7283 14.9614 13.3659 14.113 13.9797 13.257C14.6891 12.2722 14.9841 11.3177 15 11.2646C14.9761 11.2571 13.0471 10.5526 13.0232 8.43145C13.0072 6.65881 14.5456 5.81036 14.6174 5.77249C13.7406 4.55285 12.3935 4.4165 11.9232 4.38619C10.6956 4.29529 9.66737 5.02253 9.09345 5.02253ZM11.1659 3.23474C11.684 2.64386 12.0268 1.81814 11.9311 1C11.1898 1.0303 10.2971 1.46967 9.76302 2.06055C9.28476 2.58325 8.87026 3.42412 8.98186 4.22711C9.80288 4.28771 10.6478 3.82562 11.1659 3.23474Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1890_228766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.572f44918c7890c939606edbbab39cc8.svg";
export { ForwardRef as ReactComponent };